import { Typography } from '@mui/material'
import React, { ReactNode } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
import { useNavigate } from 'react-router-dom'
import { useStyles } from './HeaderRoutingWrapper.styles'
import clsx from 'clsx'
import type { CustomNavButtonProp } from '../RoutingApp/types'

type HeaderRoutingAppProps = {
  title?: string | ReactNode
  titleIconOrBadge?: React.FC
  actions?: React.FC
  hideTitle?: boolean
  subHeading?: string
  isBack?: boolean
  customNavButton?: CustomNavButtonProp
  onBack?: () => void
  isExternal?: boolean
}

export const HeaderRoutingApp: React.FC<HeaderRoutingAppProps> = ({
  title: Title,
  titleIconOrBadge: TitleIconOrBadge,
  actions: Actions,
  hideTitle = false,
  subHeading,
  isBack = false,
  customNavButton,
  onBack,
  isExternal,
}) => {
  const { classes } = useStyles({
    shouldShowCustomeNavButton:
      customNavButton?.shouldShowCustomNavButton as boolean,
    isExternal,
    isRevampEnable: true,
  })
  const navigate = useNavigate()
  return (
    <>
      {!hideTitle && (
        <div className={clsx(classes.headerContainer, classes.stickyContainer)}>
          <div className={classes.appTitle}>
            {Title ? (
              <div className={classes.appTitleHeading}>
                {isBack && (
                  <div
                    className={classes.appBackIcon}
                    data-testid={'back-button'}
                    onClick={() => (onBack ? onBack() : navigate(-1))}
                  >
                    {' '}
                    <FontAwesomeIcon
                      icon={faArrowLeft}
                      style={{
                        width: '24px',
                        height: '24px',
                        fontSize: '24px',
                        color: '#1942C5',
                      }}
                    />
                  </div>
                )}
                <div
                  className={`${
                    customNavButton?.shouldShowCustomNavButton
                      ? classes.customNavButton
                      : ''
                  }`}
                >
                  <Typography
                    variant="h1"
                    data-testid="heading"
                    className={classes.appTitleHeadingText}
                  >
                    {Title}
                  </Typography>
                </div>
                {TitleIconOrBadge ? <TitleIconOrBadge /> : <></>}
              </div>
            ) : null}
            <div data-testid="actions" className={classes.action}>
              {Actions ? <Actions /> : null}
            </div>
          </div>
          {subHeading && (
            <Typography
              data-testid="subHeading-wrapper"
              className={classes.subTitleText}
            >
              {subHeading}
            </Typography>
          )}
        </div>
      )}
    </>
  )
}
